module.exports = __webpack_public_path__ + "static/contact-cta-banner-02ee0507507486d2b6abaf1663828f07.jpg";